"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _f_logo_RGBBlue_ = _interopRequireDefault(require("../imgs/f_logo_RGB-Blue_58.png"));

var _Loader = require("./Loader");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FacebookButton = function FacebookButton(_ref) {
  var onClick = _ref.onClick,
      type = _ref.type,
      isProcessing = _ref.isProcessing;
  return _react.default.createElement("button", {
    onClick: onClick,
    className: "".concat(_formFiledModule.default.button, " ").concat(_baseModule.default.facebookButton)
  }, _react.default.createElement("span", {
    style: {
      backgroundImage: "url(".concat(_f_logo_RGBBlue_.default, ")")
    }
  }), _react.default.createElement("span", null, isProcessing ? _react.default.createElement(_Loader.ButtonLoader, null) : "".concat(type === "login" ? "Login" : "Continue", " with Facebook")));
};

var _default = FacebookButton;
exports.default = _default;